export const detectColumnTypes = (data, columns) => {
  return columns.map(col => ({
    ...col,
    type: detectType(data, col.accessorKey)
  }));
};

const detectType = (data, columnKey) => {
  const samples = data.slice(0, 100).map(row => row[columnKey]);
  
  if (samples.every(v => isValidDate(v))) return 'date';
  if (samples.every(v => /^R\$?\s*[\d.,]+$/.test(v))) return 'currency';
  if (samples.every(v => !isNaN(parseFloat(v)))) return 'number';
  
  const uniqueValues = [...new Set(samples)];
  if (uniqueValues.length <= 20 && uniqueValues.length < samples.length * 0.5) {
    return 'category';
  }
  
  return 'text';
};

const isValidDate = (value) => {
  if (!value) return false;
  const parsed = Date.parse(value);
  return !isNaN(parsed);
};
